import {
  CloseRounded as CloseIcon,
  KeyboardBackspaceRounded as BackspaceIcon,
} from '@material-ui/icons';
import { clsx } from 'clsx';
import { Button, Drawer } from '@material-ui/core';

import makeClasses from './SideBarDialog.style';

import type { SideBarDialogProps } from './sideBarDialog.model';

export function SideBarDialog(props: SideBarDialogProps) {
  const {
    marginBottomToolbar,
    marginTopToolbar,
    size,
    classes,
    preNav,
    classesHeader,
    headerTitle,
    posNav,
    classesMain,
    children,
    classesFooter,
    customActions,
    actions,
    extraActions,
    onBack,
    onClose = () => {},
    ...restDrawerProps
  } = props;

  const isHeaderTitleAsString = typeof headerTitle === 'string';
  const hasSomeAction =
    actions?.primaryBtn?.children || actions?.secondaryBtn?.children;

  const _classes = makeClasses({ marginBottomToolbar, marginTopToolbar, size });

  return (
    <Drawer
      anchor='right'
      elevation={0}
      onClose={onClose}
      ModalProps={{
        BackdropProps: {
          classes: {
            root: _classes.backdrop,
          },
        },
      }}
      classes={{
        ...{ classes },
        root: clsx(_classes.modal, classes?.root),
        paper: clsx(_classes.drawerPaper, classes?.paper),
      }}
      {...restDrawerProps}
    >
      <header className={clsx(classesHeader?.header)}>
        {preNav}
        <nav
          data-has-posnav={Boolean(posNav)}
          className={clsx(_classes.headerNav, classesHeader?.nav)}
        >
          <div className={clsx(_classes.headerNavMain, classesHeader?.main)}>
            {Boolean(onBack) && <BackspaceIcon onClick={onBack} />}
            {!isHeaderTitleAsString && headerTitle}
            {isHeaderTitleAsString && (
              <h1 className={clsx(_classes.headerTitle, classesHeader?.title)}>
                {headerTitle}
              </h1>
            )}
          </div>
          <CloseIcon onClick={e => onClose(e, 'escapeKeyDown')} />
        </nav>
        {posNav}
      </header>

      <main className={clsx(_classes.main, classesMain?.main)}>{children}</main>

      {(hasSomeAction || customActions || extraActions) && (
        <footer className={clsx(_classes.footer, classesFooter?.footer)}>
          {customActions}
          {!customActions && hasSomeAction && (
            <>
              {!!actions?.primaryBtn?.children && (
                <Button
                  fullWidth
                  variant='contained'
                  classes={{ root: _classes.primaryBtn }}
                  {...actions?.primaryBtn}
                />
              )}
              {!!actions?.secondaryBtn?.children && (
                <Button
                  fullWidth
                  variant='text'
                  classes={{ root: _classes.secondaryBtn }}
                  {...actions?.secondaryBtn}
                />
              )}
              {extraActions}
            </>
          )}
        </footer>
      )}
    </Drawer>
  );
}
